export const MAINAPIURL = "https://api.ceylonikacosmetics.com/api";
//export const MAINAPIURL = "https://ceylonika-qa-api.azurewebsites.net/api";
export const SYSTEMNAME = "Ceylonika ERP";
export const MAINVERSION = "3.0.2";
export const CUSTOMERNAME = "Ceylonika";
export const APPBACKGROUND_COLOR = "#ceebe9";